<template>
  <maoc-card>
     <v-btn
        elevation="2"
        icon
        tile
        class="float-right"
        @click="copyStuff"
      >
        <v-icon  class="mdi mdi-content-copy"></v-icon>
      </v-btn>
      <div ref="previewContent" class="content-preview">
        <h3 class="form-header">
          {{$t('countries.' + req.entity.country, 'en') }}
          {{titleDate}}
          {{req.request_time.time}}
          {{handlingCodes}}
          {{req.source_evaluation + req.intel_evaluation}}
        </h3>
        <div class="section_header">
          <p><span class="label">Request:</span> {{$t(req.request.requestType, 'en')}}</p>
          <p v-if="req.request.requestNumber"><span class="label">VOI/POI:</span> {{ req.request.requestNumber }}</p>
          <p v-if="req.request.requestCategory"><span class="label">Request Category:</span> {{$t(req.request.requestCategory, 'en')}}</p>
          <p v-if="req.entity.agency"><span class="label">Agency:</span> {{ req.entity.agency }}</p>
          <p v-if="req.entity.unit"><span class="label">Unit:</span> {{ req.entity.unit }}</p>
          <p v-if="req.entity.operation"><span class="label">Operation:</span> {{ req.entity.operation }}</p>
          <p v-if="req.entity.judicialNumber">
              <span class="label">{{ $t('judicial_number', 'en')}}:</span>
              {{ req.entity.judicialNumber }}
          </p>
          <p v-if="req.entity.judicialAuthority">
            <span class="label">{{ $t('judicial_authority', 'en')}}:</span>
            {{ req.entity.judicialAuthority }}
          </p>
          <p v-if="req.entity.sharing">
            <span class="label">The Information on the case is being shared with:</span>{{ req.entity.sharing_details }}
          </p>
        </div>

        <vessel-preview
          v-if="req.vessel_details"
          :vessel="req.vessel_details"
          title="Vessel"
        ></vessel-preview>
        <vessel-preview
          v-if="req.aeroplane_details"
          title="Aeroplane"
          :vessel="req.aeroplane_details"></vessel-preview>

        <div v-if="req.owner_data && req.owner_data.length !== 0" class="section_header">
          <h3>Owners</h3>
          <ul>
            <li v-for="(owner, index) in req.owner_data" :key=index>
              <p>
                <span class="label pt-2" v-if="owner.type == 'person'">Person Name:</span>
                <span class="label pt-2" v-if="owner.type == 'company'">Company Name:</span>
                {{ owner.name }}
              </p>
              <p v-if="owner.birthdate"><span class="label" >{{$t('date_of_birth', 'en')}}:</span> {{ owner.birthdate }}</p>
              <p v-if="owner.nationality"><span class="label" >{{$t('nationality', 'en')}}:</span> {{ $t('countries.' + owner.nationality) }}</p>
              <p v-if="owner.document_type"><span class="label" >{{$t('document_type', 'en')}}:</span> {{ $t('documents.' + owner.document_type) }}</p>
              <p v-if="owner.document_number"><span class="label" >{{$t('document_number', 'en')}}:</span> {{ owner.document_number }}</p>
              <p v-if="owner.address"><span class="label" >{{$t('address', 'en')}}:</span> {{ owner.address }}</p>
              <p v-if="owner.website"><span class="label" >{{$t('website', 'en')}}:</span> {{ owner.website }}</p>
              <p v-if="owner.year_formed"><span class="label" >{{$t('year_formed', 'en')}}:</span> {{ owner.year_formed }}</p>
              <p v-if="owner.rank"><span class="label" >{{$t('rank', 'en')}}:</span> {{ $t('ranks.' + owner.rank) }} (Owner is onboard)</p>
              <p v-if="owner.details"><span class="label" >{{$t('details', 'en')}}:</span> {{ owner.details }}</p>
            </li>
          </ul>
        </div>

        <div v-if="req.crew_data && req.crew_data.length !== 0" class="section_header">
          <p><span class="label">Crew:</span></p>
          <ul>
            <li v-for="(crewmember, index) in req.crew_data" :key=index>
              {{ formatCrewmember(crewmember) }}
              <p v-if="crewmember.details">{{$t('details', 'en')}}: {{ crewmember.details }}</p>
            </li>
          </ul>
        </div>

        <div v-if="req.related_vessels && req.related_vessels.length !== 0" class="section_header">
          <h3>{{ $t('other_linked_vessels') }}</h3>
          <div v-for="(vessel, index) in req.related_vessels" :key=index>
            <vessel-preview
              :vessel="vessel"
              :title="vessel.vessel_type == 'vessel' ? 'Vessel' : 'Aeroplane'"
            ></vessel-preview>
          </div>
        </div>

        <div class="section_header">
          <h3>{{ $t('summary_title')}}</h3>
          <p class="py-2"> {{ req.summary.summary }} </p>
          <p v-if="req.summary.groupNationality"><span class="label" >OGC {{$t('nationality', 'en')}}:</span> {{ $t('countries.' + req.summary.groupNationality) }}</p>
          <p v-if="req.summary.drugs"><span class="label" >{{$t('drug_type_message', 'en')}}:</span> {{ req.summary.drugs }}</p>
          <p v-if="req.summary.modusOperandi"><span class="label" >{{$t('modus_operandi', 'en')}}:</span> {{ req.summary.modusOperandi }}</p>
          <p v-if="req.summary.groupLinks"><span class="label" >{{$t('investigation_links_message', 'en')}}:</span> {{ req.summary.groupLinks }}</p>
          <p v-if="req.summary.vessel_possible_destinations"><span class="label" >{{$t('investigation_links_message', 'en')}}:</span> {{ req.summary.possibleDestinations }}</p>
          <p v-if="req.summary.infoType && req.summary.infoType.length > 0"><span class="label" >{{$t('information_type', 'en')}}:</span> {{ req.summary.infoType.map((element) => $t(element)).join(', ') }}</p>
        </div>
      </div>

      <div class="section_header">
        <p
          v-if="req.images && req.images.length > 0"
          class="py-2 preview_callout">
          This request contains images.
        </p>
        <!--
        <p
          v-if="req.attachments && req.attachments.length > 0"
          class="py-2 preview_callout">
          This request contains attachments.
        </p>
        -->
      </div>
  </maoc-card>
</template>

<script>
import VesselPreview from './ui/VesselPreview.vue'
import MaocCard from './ui/MaocCard.vue'

export default {
  components: {
    MaocCard,
    VesselPreview
  },
  name: 'RequestPreview',
  props: {
    req: Object
  },
  data: vm => ({
    translatableStrings: [
      'nationality',
      'document_type',
      'rank'
    ]
  }),
  computed: {
    handlingCodes () {
      var codes = []
      const list = ['h1', 'h2', 'h3']
      for (const idx in list) {
        if (this.req.handling_codes[list[idx]]) {
          codes.push(list[idx].toUpperCase())
        }
      }
      return codes.join(' ')
    },
    titleDate () {
      const [day, month, year] = this.req.request_time.date.split('/')
      return day + '/' + month + '/' + year.slice(-2)
    }
  },
  methods: {
    setMailPreview (subject, body) {
      this.subject = subject
      this.body = body
    },
    selectText (element) {
      var range
      if (document.selection) {
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    },
    copyStuff () {
      this.selectText(this.$refs.previewContent)
      document.execCommand('copy')
      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty()
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges()
        }
      } else if (document.selection) {
        document.selection.empty()
      }
    },
    copyContent () {
      return this.$refs.previewContent.innerText
    },
    formatCrewmember (crewmember) {
      var attrs = []

      const keys = [
        'name',
        'birthdate',
        'nationality',
        'document_type',
        'document_number',
        'rank'
      ]

      const keyMap = {
        nationality: 'countries',
        rank: 'all_ranks',
        document_type: 'documents'
      }

      const module = this

      keys.forEach(function (key) {
        if (crewmember[key]) {
          if (module.translatableStrings.includes(key)) {
            attrs.push(module.$t(keyMap[key] + '.' + crewmember[key], 'en'))
          } else {
            attrs.push(crewmember[key])
          }
        }
      })

      return attrs.join(' ')
    }
  }
}
</script>
